import Slider from 'react-slick';
import "./ImageSlider.css";

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
const settings = {
    dots: false,
    arrows: true, 
    infinite: true,
    speed: 500,
    slidesToShow:2,
    slidesToScroll: 1,
    swipeToSlide: true,
    centerMode: true,
};

const SliderHolly = () => (
    <Slider {...settings} className="flex">
        <img src="/products/Holly/Product gallery/1.jpg" alt="" className=" h-[500px] object-contain " />
        <img src="/products/Holly/Product gallery/2.jpg" alt="" className="h-[500px] object-contain " />
        <img src="/products/Holly/Product gallery/3.jpg" alt="" className=" h-[500px] object-contain " />
        <img src="/products/Holly/Product gallery/4.jpg" alt="" className=" h-[500px] object-contain " />
        <img src="/products/Holly/Product gallery/5.jpg" alt="" className=" h-[500px] object-contain " />
        <img src="/products/Holly/Product gallery/6.jpg" alt="" className=" h-[500px] object-contain " />
        <img src="/products/Holly/Product gallery/7.jpg" alt="" className=" h-[500px] object-contain " />

    </Slider>
);





export default SliderHolly;